/** Admin investor account status values (list filters and status updates). */
export const USER_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const LEGACY_USER_STATUS_MAP = {
  enabled: "active",
  disabled: "inactive",
  suspended: "inactive",
  deactivated: "inactive",
};

/** Maps API / legacy status strings to a valid `USER_STATUS_OPTIONS` value. */
export function normalizeUserStatus(status, fallback = "inactive") {
  const raw = String(status ?? "").trim().toLowerCase();
  if (!raw || raw === "—") return fallback;
  const key = raw.replaceAll(/\s+/g, "_");
  if (LEGACY_USER_STATUS_MAP[key]) return LEGACY_USER_STATUS_MAP[key];
  if (USER_STATUS_OPTIONS.some((option) => option.value === key)) return key;
  return fallback;
}

export function userStatusLabel(status) {
  const key = normalizeUserStatus(status, "");
  if (!key) return "—";
  const match = USER_STATUS_OPTIONS.find((option) => option.value === key);
  return match?.label ?? String(status);
}
